

import React from "react";
import QRCodeGenerator from "../common/QRCodeGenerator";


const StockQRPrint = React.forwardRef(({ data, numberOfLabels }, ref) => {
  const totalLabels = numberOfLabels || 35; // Default to 35 labels if not provided

  const qrBoxes = Array.from({ length: totalLabels }).map((_, idx) => (
    <div
      key={idx}
      style={{
        border: "1px solid black",
        padding: "10px",
        fontSize: "12px",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "140px", // Adjust height as needed to fit 7 vertically
      }}
    >
      <p style={{ margin: "5px 0" }}>{data?.materialName}</p>
      <QRCodeGenerator
        value={`Stock Code: ${data?.stockCode} | Description: ${data?.materialName}`}
        size={80} // Reduced size to fit all QR codes on one page
      />
      <p style={{ margin: "5px 0" }}>{data?.stockCode}</p>
    </div>
  ));

  return (
    <div style={{ display: "none" }}>
      <div ref={ref}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)", // 5 columns
            gridTemplateRows: "repeat(7, auto)",   // 7 rows
            gap: "10px",
            padding: "10px",
            boxSizing: "border-box",
            pageBreakInside: "avoid", // Prevent breaking the grid
          }}
        >
          {qrBoxes}
        </div>
      </div>
    </div>
  );
});

export default StockQRPrint;
